import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Space, Row, Col, Table, Typography } from 'antd';

import { CustomButton } from '../../../components';
import SpinLoad from '../../../components/SpinLoad';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import Paragraph from 'antd/lib/typography/Paragraph';

const { Title } = Typography;

const LegalPersonForm = memo(
  ({ dataSource, loading, onFinish, rowSelection, title }) => {
    const [form] = Form.useForm();

    const columns = [
      {
        title: 'Nombres y apellidos',
        dataIndex: 'nombre_completo',
        key: 'nombre_completo',
      },
      {
        title: 'Tipo de Documento',
        dataIndex: 'tipo_identificacion',
        key: 'tipo_identificacion',
      },
      {
        title: 'Nro. Documento',
        dataIndex: 'numero_identificacion',
        key: 'numero_identificacion',
      },
      {
        title: 'Fecha de expedición',
        dataIndex: 'fecha_expedicion_documento',
        key: 'fecha_expedicion_documento',
      },
      {
        title: 'Celular',
        dataIndex: 'numero_celular',
        key: 'numero_celular',
      },
      {
        title: 'Dirección',
        dataIndex: 'notificacion_direccion',
        key: 'notificacion_direccion',
      },
      {
        title: 'País',
        dataIndex: 'pais',
        key: 'notificacion_pais',
      },
      {
        title: 'Departamento',
        dataIndex: 'departamento',
        key: 'departamento',
      },
      {
        title: 'Ciudad',
        dataIndex: 'ciudad',
        key: 'ciudad',
      },
      {
        title: 'Correo electrónico',
        dataIndex: 'notificacion_email',
        key: 'notificacion_email',
      },
    ];

    return (
      <>
        <Form
          form={form}
          name="location_form"
          layout="vertical"
          onFinish={onFinish}
        >
          <Row align="bottom">
            <Col span={24}>
              <Title level={5}>Búsqueda por identificación</Title>
              <Row align="bottom">
                <Col span={11}>
                  <Form.Item label="Razón social" name="nombre">
                    <Input allowClear placeholder="Búsqueda por razón social" />
                  </Form.Item>
                </Col>
                <Col span={11} offset={2}>
                  <Form.Item
                    label="NIT o número de documento equivalente"
                    name="documento"
                  >
                    <Input
                      type="number"
                      allowClear
                      placeholder="Búsqueda por documento"
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item label="Sigla o nombre comercial" name="sigla">
                    <Input allowClear placeholder="Sigla o nombre comercial" />
                  </Form.Item>
                </Col>
                <Col span={11} offset={2}>
                  <Form.Item label="Correo electrónico" name="email">
                    <Input allowClear placeholder="Correo electrónico" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="space-between">
            <Form.Item>
              <Space>
                <CustomButton loading={loading} text="Buscar" />
                <CustomButton
                  type="default"
                  loading={loading}
                  text={
                    <a href={`${INTERNAL_LINKS.LEGAL_PERSON}`} target="_blank">
                      Crear contratista
                    </a>
                  }
                />
              </Space>
            </Form.Item>
            <CustomButton
              htmlType="button"
              onClick={() => {
                form.resetFields();
              }}
              loading={loading}
              type="default"
              danger
              text="Borrar filtros"
            />
          </Row>
        </Form>
        <SpinLoad loading={loading}>
          <Table
            rowSelection={{ ...rowSelection }}
            columns={columns}
            rowKey="id"
            scroll={{ x: 2200 }}
            dataSource={dataSource}
            title={title}
          />
        </SpinLoad>
      </>
    );
  },
);

LegalPersonForm.propTypes = {
  dataSource: PropTypes.array,
  ids: PropTypes.object,
  loading: PropTypes.bool,
  rowSelection: PropTypes.func,
};

LegalPersonForm.defaultProps = {
  dataSource: [],
  ids: {},
  loading: false,
  rowSelection: () => {},
};

export default LegalPersonForm;
